/**
 * All owner-web copy, Indonesian only (D22). One module, so a later translation is a data change.
 * API error codes map to plain words here; the API's technical `detail` is never shown (§6.3).
 */
export const t = {
  appName: 'GammaPOS',
  authPitch: 'Kasir tetap jalan walau internet putus.',
  loading: 'Memuat…',

  loginTitle: 'Masuk',
  phone: 'Nomor HP',
  password: 'Kata sandi',
  newPasswordLabel: 'Kata sandi (min. 8 karakter)',
  confirmPassword: 'Ulangi kata sandi',
  showPassword: 'Tampilkan',
  hidePassword: 'Sembunyikan',
  passwordMismatch: 'Kata sandi tidak sama. Ketik ulang.',
  loginButton: 'Masuk',
  noAccount: 'Belum punya akun? Daftar',
  haveAccount: 'Sudah punya akun? Masuk',

  forgotPassword: 'Lupa kata sandi?',
  forgotTitle: 'Lupa kata sandi',
  forgotBody: 'Masukkan nomor HP akun Anda. Kami kirim kode verifikasi lewat SMS, lalu Anda membuat kata sandi baru.',
  forgotSend: 'Kirim kode',
  forgotCodeSent: (phone: string) =>
    `Jika ${phone} terdaftar, kami mengirim kode 6 angka lewat SMS. Kode berlaku 5 menit.`,
  forgotVerify: 'Verifikasi',
  forgotChangeNumber: 'Ganti nomor HP',
  forgotNewTitle: 'Buat kata sandi baru',
  forgotSave: 'Simpan kata sandi baru',
  forgotDone: 'Kata sandi sudah diganti. Silakan masuk dengan kata sandi yang baru.',
  backToLogin: 'Kembali ke halaman masuk',

  reopenLink: 'Buka kembali akun ini',
  reopenTitle: 'Buka kembali akun',
  reopenBody:
    'Masukkan nomor HP akun yang ditutup. Kami kirim kode verifikasi lewat SMS. Akun hanya bisa dibuka kembali dalam 30 hari sejak ditutup.',
  reopenSend: 'Kirim kode',
  reopenCodeSent: (phone: string) =>
    `Jika akun ${phone} bisa dibuka kembali, kami mengirim kode 6 angka lewat SMS. Kode berlaku 5 menit.`,
  reopenVerify: 'Buka kembali akun',
  reopenDone:
    'Akun sudah dibuka kembali. Silakan masuk dengan kata sandi lama; kalau lupa, pilih Lupa kata sandi. Device kasir perlu diaktifkan lagi.',

  signupTitle: 'Daftar',
  inviteCode: 'Kode undangan',
  ownerName: 'Nama Anda',
  businessName: 'Nama usaha',
  outletName: 'Nama cabang',
  outletCode: 'Kode cabang (untuk nomor struk, mis. SBY01)',
  signupButton: 'Daftar',
  otpTitle: 'Verifikasi nomor HP',
  otpSent: (phone: string) => `Kami mengirim kode 6 angka lewat SMS ke ${phone}. Kode berlaku 5 menit.`,
  otpCode: 'Kode verifikasi',
  otpVerifyButton: 'Verifikasi dan daftar',
  otpResend: 'Kirim ulang kode',
  otpResendIn: (seconds: number) => `Kirim ulang kode (${seconds} detik)`,
  otpChangeData: 'Ubah data pendaftaran',
  businessType: 'Jenis usaha',
  businessServices: 'Jasa',
  businessServicesHint: 'Menjual jasa: barbershop, salon, laundry, bengkel',
  businessFood: 'Makanan & Minuman',
  businessFoodHint: 'Menyajikan makanan atau minuman: restoran, kafe, warung makan',
  businessRetail: 'Toko / Retail',
  businessRetailHint: 'Menjual barang: toko kelontong atau warung sembako, minimarket, apotek',
  businessOther: 'Lainnya',
  businessOtherHint: 'Kasir umum, kalau belum ada yang cocok',
  businessExplain: {
    food: [
      'Pilih meja dan Dine In atau Take Away.',
      'Catatan per menu, misalnya Pedas atau Kuah pisah.',
      'Tiket dapur dan pesanan yang dibayar nanti.',
      'Warung yang menjual makanan jadi masuk di sini.',
    ],
    services: ['Pilih staf yang mengerjakan tiap layanan.', 'Komisi atau bagi hasil otomatis, lengkap dengan laporannya.'],
    retail: [
      'Cari produk dengan cepat, cocok untuk banyak barang.',
      'Tanpa komisi dan tanpa meja, transaksi singkat.',
      'Warung sembako atau toko kelontong masuk di sini, bukan di Makanan & Minuman.',
    ],
    other: ['Produk dan layanan sederhana.', 'Fitur lain dinyalakan sendiri di Pengaturan.'],
  } as const,
  businessSubtypeTitle: 'Pilih yang paling dekat (boleh dilewati)',
  businessTypeNote: 'Tulis jenis usaha Anda (boleh dilewati)',
  businessChangeLater: 'Bisa diubah nanti di Pengaturan.',
  businessTypeRequired: 'Pilih jenis usaha dulu.',
  businessSubtypes: {
    restaurant: 'Restoran',
    cafe: 'Kafe',
    fastfood: 'Fast food',
    food_court: 'Food court',
    foodtruck: 'Foodtruck',
    warung: 'Warung & kedai makanan',
    drinks: 'Warung & kedai minuman',
    bakery: 'Toko kue (bakery)',
    catering: 'Katering',
    street_food: 'Makanan & minuman keliling',
    food_other: 'Lainnya',
    barbershop: 'Barbershop',
    salon_spa: 'Salon & spa',
    skincare: 'Skincare',
    massage: 'Refleksi & pijat',
    car_wash: 'Cuci kendaraan',
    workshop: 'Bengkel',
    laundry: 'Laundry pakaian',
    shoe_laundry: 'Laundry sepatu',
    garment: 'Konveksi',
    repair: 'Reparasi lainnya',
    photo: 'Studio foto',
    printing: 'Percetakan digital',
    rental: 'Rental',
    rental_ps: 'Rental PS',
    sports_field: 'Sewa lapangan',
    isp: 'Internet (ISP)',
    services_other: 'Lainnya',
    grocery: 'Toko kelontong',
    minimarket: 'Minimarket & swalayan',
    packaged_food: 'Makanan & minuman kemasan',
    pharmacy: 'Apotek & toko obat',
    clinic: 'Klinik',
    cosmetics: 'Toko kosmetik',
    phone_electronics: 'HP, komputer & elektronik',
    clothing: 'Pakaian & tekstil',
    building: 'Bahan bangunan',
    petshop: 'Petshop',
    florist: 'Toko bunga',
    online_seller: 'Penjual online',
    retail_other: 'Lainnya',
  } as const,

  changePasswordTitle: 'Ganti kata sandi',
  changePasswordBody: 'Kata sandi Anda baru diatur ulang oleh tim GammaPOS. Buat kata sandi baru dulu.',
  currentPassword: 'Kata sandi sementara',
  newPassword: 'Kata sandi baru (min. 8 karakter)',
  save: 'Simpan',

  navSubscription: 'Langganan',
  groupSummary: 'Ringkasan',
  groupManage: 'Kelola',
  groupAccount: 'Akun',
  menuMain: 'Menu utama',
  menuBottom: 'Menu',
  accountMenu: 'Menu akun',
  skipToContent: 'Langsung ke isi halaman',
  navDashboard: 'Dashboard Insight',
  navGroupOverview: 'Ringkasan & Analitik',
  navGroupCatalog: 'Katalog & Tim',
  navGroupSettings: 'Pengaturan & Sistem',
  openMenu: 'Buka menu navigasi',
  closeMenu: 'Tutup menu navigasi',
  dashTitle: 'Dashboard Insight',
  dashSub: 'Pahami pola ramai pelanggan, hari terbaik, dan produk paling menguntungkan.',
  navHome: 'Laporan',
  navSales: 'Transaksi',
  navData: 'Layanan & Staf',
  navDevices: 'Device',
  navSettings: 'Pengaturan',
  logout: 'Keluar',

  // ---------- report (P4-05/06)
  today: 'Hari ini',
  yesterday: 'Kemarin',
  last7: '7 hari',
  thisMonth: 'Bulan ini',
  customPeriod: 'Pilih tanggal dan jam',
  printReport: 'Cetak laporan',
  byCategory: 'Per kategori',
  periodFrom: 'Dari',
  periodTo: 'Sampai',
  periodShow: 'Tampilkan',
  periodEndBeforeStart: 'Waktu selesai harus setelah waktu mulai.',
  netSales: 'Penjualan bersih',
  salesCount: (n: number) => `${n} transaksi`,
  discountTotal: (v: string) => `diskon ${v}`,
  voided: (n: number, v: string) => `${n} dibatalkan (${v})`,
  noSales: 'Belum ada penjualan di periode ini.',
  noSalesBody: 'Transaksi muncul di sini begitu device kasir mengirimnya. Cek status device kasir di menu Device.',
  staffCommission: 'Komisi staf',
  commissionNote: 'Dihitung dari harga sebelum diskon. Transaksi yang dibatalkan tidak dihitung.',
  noStaff: 'Tanpa staf',
  services: (n: number) => `${n} layanan`,
  noCommission: 'Tanpa komisi',
  byMethod: 'Cara bayar',
  byItem: 'Layanan & produk',
  sold: (n: number) => `${n} terjual`,
  byDay: 'Per hari',
  cashTitle: 'Kas per sesi',
  cashOpen: 'Masih buka',
  cashExpected: 'Seharusnya',
  cashActual: 'Dihitung',
  cashDiff: 'Selisih',
  cashLine: (open: string, sales: string, inOut: string) => `Awal ${open} · tunai ${sales} · masuk/keluar ${inOut}`,
  phonesTitle: 'Device kasir',
  phoneLine: (letter: string) => `Device ${letter}`,
  phoneRejected: (n: number) => `${n} transaksi ditolak server — hubungi tim GammaPOS`,
  exportTitle: 'Unduh laporan (CSV)',
  exportNote: 'File bisa dibuka di Excel dan Google Sheets.',
  exportSales: 'Transaksi',
  exportItems: 'Rincian layanan',
  exportItemsMenu: 'Rincian menu',
  exportItemsProducts: 'Rincian produk',
  exportItemsOther: 'Rincian item',
  exportCommission: 'Komisi staf',
  exportCash: 'Kas',
  conflictBanner: (n: number) => `${n} perubahan dari device kasir tidak dipakai karena sudah Anda ubah di web.`,
  seeDetail: 'Lihat',
  methods: { cash: 'Tunai', qris: 'QRIS', transfer: 'Transfer', other: 'Lainnya' } as Record<string, string>,

  // ---------- transactions
  salesTitle: 'Transaksi',
  searchReceipt: 'Cari nomor struk atau nomor urut',
  receiptSeq: (n: number) => `No. urut ${n}`,
  loadMore: 'Muat lagi',
  voidedBadge: 'Dibatalkan',
  cashier: 'Kasir',
  back: 'Kembali',
  subtotal: 'Subtotal',
  discount: 'Diskon',
  total: 'Total',
  by: (name: string) => `oleh ${name}`,
  commission: 'komisi',
  voidInfo: (by: string, reason: string) => `Dibatalkan oleh ${by}: ${reason}`,
  receivedAt: 'Diterima server',

  // ---------- master data (P4-08)
  dataTitle: 'Layanan & Staf',
  menuTitle: 'Menu',
  menuAndStaff: 'Menu & Staf',
  addMenu: 'Tambah menu',
  noMenu: 'Belum ada menu. Tambahkan di sini atau di device kasir.',
  noCategory: 'Tanpa kategori',
  addCategory: 'Tambah kategori',
  newCategory: 'Nama kategori baru',
  categoriesLabel: 'Kategori',
  allCategories: 'Semua',
  renameCategory: 'Ubah nama',
  removeCategory: 'Hapus kategori',
  categoryName: 'Nama kategori',
  confirmRemoveCategory: (name: string, n: number) =>
    n === 0 ? `Hapus kategori ${name}? Tidak ada item di dalamnya.` : `Hapus kategori ${name}? ${n} item di dalamnya tidak ikut terhapus dan menjadi Tanpa kategori.`,
  categoryAdded: (name: string) => `Kategori ${name} ditambahkan.`,
  categoryRenamed: (name: string) => `Kategori diubah menjadi ${name}.`,
  categoryRemoved: (name: string) => `Kategori ${name} dihapus.`,
  menuAdded: 'Menu berhasil ditambahkan.',
  serviceAdded: 'Layanan berhasil ditambahkan.',
  productAdded: 'Produk berhasil ditambahkan.',
  productOrServiceAdded: 'Produk atau layanan berhasil ditambahkan.',
  productsTitle: 'Produk',
  productsAndStaff: 'Produk & Staf',
  addProduct: 'Tambah produk',
  noProducts: 'Belum ada produk. Tambahkan di sini atau di device kasir.',
  productsServicesTitle: 'Produk & Layanan',
  productsServicesAndStaff: 'Produk, Layanan & Staf',
  addProductOrService: 'Tambah produk atau layanan',
  noProductsServices: 'Belum ada produk atau layanan. Tambahkan di sini atau di device kasir.',
  changesSaved: 'Perubahan disimpan.',
  emptyCategory: 'Belum ada item di kategori ini.',
  tabItems: 'Layanan & produk',
  tabStaff: 'Staf',
  tabRules: 'Komisi',
  add: 'Tambah',
  edit: 'Ubah',
  cancel: 'Batal',
  name: 'Nama',
  type: 'Jenis',
  service: 'Layanan',
  product: 'Produk',
  category: 'Kategori (boleh kosong)',
  price: 'Harga',
  cost: 'Harga beli (boleh kosong)',
  active: 'Aktif',
  inactive: 'Nonaktif',
  ruleFor: 'Layanan',
  ruleStaff: 'Staf',
  ruleAllStaff: 'Semua staf',
  commissionSwitch: 'Komisi staf',
  commissionSwitchHint: 'Staf mendapat bagian dari tiap penjualan item ini.',
  commissionProductNote: 'Untuk produk, komisi dihitung dari harga jual.',
  commissionNeedRule: 'Atur komisinya, atau matikan komisi staf.',
  commissionTooHigh: 'Komisi nominal paling besar Rp 1.000.000.000.',
  priceTooHigh: 'Harga paling besar Rp 1.000.000.000.',
  costTooHigh: 'Harga beli paling besar Rp 1.000.000.000.',
  commissionOffNote: 'Aturan komisi yang ada akan dihapus saat Anda menyimpan.',
  commissionAllHint: 'Kosongkan bila tidak ada aturan umum',
  commissionStaffHint: 'Kosongkan: ikut aturan umum',
  commissionPercentShort: 'Persen',
  commissionFixedShort: 'Nominal',
  commissionValueFor: (who: string) => `Besar komisi ${who}`,
  commissionTypeFor: (who: string) => `Jenis komisi ${who}`,
  itemSavedCommissionFailed: 'Item tersimpan, tetapi komisinya belum tersimpan. Buka item ini lagi untuk mengatur komisinya.',
  ruleType: 'Jenis komisi',
  ruleFixed: 'Rupiah per layanan',
  rulePercent: 'Persen dari harga',
  ruleRate: 'Besar komisi',
  ruleRatePercent: 'Persen (mis. 40 atau 12,5)',
  noItems: 'Belum ada layanan. Tambahkan di sini atau di device kasir.',
  noStaffYet: 'Belum ada staf.',
  noRules: 'Belum ada aturan komisi.',
  syncNote: 'Perubahan dikirim ke device kasir saat device itu sinkron berikutnya.',
  conflictsTitle: 'Perubahan dari device kasir yang tidak dipakai',
  conflictLine: (field: string, name: string, device: string, server: string) =>
    `${field} · ${name}: device kasir mengubah ke ${device}, yang dipakai ${server} (dari web).`,
  markSeen: 'Tandai sudah dibaca',
  fields: {
    price: 'Harga',
    name: 'Nama',
    cost: 'Harga beli',
    category: 'Kategori',
    item_type: 'Jenis',
    active: 'Status',
    rate: 'Besar komisi',
    rule_type: 'Jenis komisi',
    role: 'Peran',
    pin_hash: 'PIN',
    pin_salt: 'PIN',
  } as Record<string, string>,

  // ---------- subscription (P6-10)
  subTitle: 'Langganan',
  stateTrial: (days: number) => `Masa percobaan: ${days} hari lagi`,
  stateActive: (days: number) => `Langganan aktif: ${days} hari lagi`,
  stateGrace: (days: number) => `Langganan berakhir ${days} hari lalu. Laporan masih bisa dibuka sampai masa tenggang habis.`,
  stateExpired: 'Langganan berakhir. Laporan dan unduhan CSV dinonaktifkan. Mencatat transaksi di device kasir tetap berjalan, dan semua data Anda tetap bisa diunduh.',
  bannerTrialEnding: (days: number) => `Masa percobaan tinggal ${days} hari.`,
  bannerGrace: 'Langganan sudah berakhir. Perpanjang supaya laporan tetap bisa dibuka.',
  bannerExpired: 'Langganan berakhir, laporan dinonaktifkan.',
  bannerAction: 'Kelola langganan',
  validUntil: (d: string) => `Berlaku sampai ${d}`,
  choosePlan: 'Pilih paket',
  planLine: (months: number, days: number) => `${months} bulan · ${days} hari`,
  monthNote: 'Satu bulan dihitung 30 hari. Waktu langganan ditambahkan di atas sisa waktu Anda.',
  pay: 'Bayar',
  paying: 'Membuka pembayaran…',
  checkoutOff: 'Pembayaran online belum aktif. Hubungi tim GammaPOS untuk memperpanjang.',
  waitingPayment: 'Menunggu konfirmasi pembayaran…',
  waitingHint: 'Biasanya beberapa detik. Halaman ini memeriksa sendiri; Anda tidak perlu memuat ulang.',
  paidOk: (d: string) => `Pembayaran diterima. Langganan aktif sampai ${d}.`,
  payFailed: 'Pembayaran tidak berhasil atau kedaluwarsa. Anda bisa memilih paket lagi.',
  payRefunded: 'Pembayaran ini sudah dikembalikan.',
  openPayment: 'Lanjutkan pembayaran',
  orders: 'Riwayat pembayaran',
  orderStatus: { pending: 'Menunggu', paid: 'Lunas', failed: 'Gagal', expired: 'Kedaluwarsa', refunded: 'Dikembalikan' } as Record<string, string>,
  voucherTitle: 'Punya kode voucher?',
  voucherLabel: 'Kode voucher',
  voucherRedeem: 'Pakai voucher',
  voucherOk: (days: number) => `Voucher dipakai: ${days} hari ditambahkan.`,
  reportsLocked: 'Laporan dinonaktifkan karena langganan berakhir.',
  reportsLockedBody: 'Data Anda tetap aman dan device kasir tetap mencatat transaksi. Perpanjang langganan untuk membuka laporan lagi.',

  // ---------- history and data (P4-12, C5)
  historyTitle: 'Riwayat perubahan',
  historySub: 'Siapa mengubah apa dan kapan, dari yang terbaru.',
  historyFilter: 'Jenis perubahan',
  historyAll: 'Semua',
  historyFilterEmpty: 'Tidak ada perubahan untuk jenis ini.',
  historyLimit: 'Menampilkan 500 perubahan terbaru.',
  historyLinkHint: 'Siapa mengubah harga, staf, dan pengaturan',
  colWhen: 'Waktu',
  colWhat: 'Kegiatan',
  colBy: 'Oleh',
  pagination: 'Halaman riwayat',
  previous: 'Sebelumnya',
  next: 'Berikutnya',
  pageNumber: (n: number) => `Halaman ${n}`,
  showing: (from: number, to: number, total: number) => `Menampilkan ${from}-${to} dari ${total}`,
  historyEmpty: 'Belum ada perubahan tercatat.',
  rawExportTitle: 'Semua data Anda',
  rawExportBody: 'Unduh semua transaksi, layanan, staf, dan aturan komisi dalam satu file zip. Selalu tersedia.',
  rawExportButton: 'Unduh semua data',

  devicesTitle: 'Device',
  devicesEmpty: 'Belum ada device kasir. Buat kode aktivasi, lalu ketik kodenya di aplikasi GammaPOS di device kasir.',
  deviceActive: 'Aktif',
  deviceRevoked: 'Diganti',
  lastSync: 'Terakhir sinkron',
  never: 'Belum pernah',
  newCode: 'Buat kode aktivasi',
  replaceCode: 'Ganti device kasir',
  pendingReport: (n: number, when: string) =>
    n === 0 ? `Semua transaksi sudah terkirim (dilaporkan ${when})` : `${n} transaksi belum terkirim (dilaporkan ${when})`,
  pendingUnknown: 'Jumlah transaksi yang belum terkirim belum dilaporkan device ini.',
  replaceSafe: 'Device lama baru saja melaporkan semua transaksinya sudah terkirim. Device lama berhenti begitu device baru diaktifkan.',
  replaceNotSafeTitle: 'Device lama mungkin masih menyimpan transaksi yang belum terkirim',
  replaceNotSafe: (receipt: string | null, when: string, seq: number | null = null) =>
    `Transaksi setelah ${receipt ?? 'struk pertama'}${receipt && seq ? ` (urutan ke-${seq})` : ''} di device lama belum terkirim. Terakhir sinkron: ${when}. ` +
    'Device lama langsung berhenti mencatat transaksi, tapi masih bisa mengirim sisa transaksinya sendiri begitu tersambung internet.',
  replaceTip:
    'Nyalakan internet di device lama dan buka aplikasinya: sisa transaksi terkirim sendiri, tidak perlu menghubungi siapa pun. ' +
    'Atau tunggu sampai "Semua transaksi sudah aman", lalu muat ulang halaman ini.',
  replaceAck: 'Saya mengerti, ganti device sekarang',
  replaceLost: 'Device lama hilang atau dicuri',
  replaceLostHint:
    'Centang kalau device lama tidak boleh mengirim apa pun lagi. Sisa transaksinya baru bisa diselamatkan lewat tim GammaPOS. ' +
    'Kosongkan kalau device lama masih ada di tangan Anda.',
  replaceRecover: 'Transaksi yang dibuat device lama setelah penggantian ditolak otomatis.',
  deviceFlushing: 'Boleh kirim sisa transaksi',
  closeFlush: 'Tutup pengiriman',
  closeFlushHint: 'Tutup kalau device lama ini ternyata hilang atau tidak akan dinyalakan lagi.',
  flushClosed: 'Pengiriman dari device lama sudah ditutup.',
  refresh: 'Muat ulang',
  codeValidUntil: (time: string) => `Ketik kode ini di device kasir. Berlaku sampai ${time}.`,

  settingsTitle: 'Pengaturan',
  settingsSub: 'Profil, data cabang, kata sandi, dan unduhan data.',
  settingsMore: 'Pengaturan lainnya',
  outletInfo: 'Info cabang',
  profileTitle: 'Profil',
  profileHint: '',
  profileOwner: 'Nama pemilik',
  profilePhone: 'Nomor HP',
  profileBusiness: 'Nama usaha',
  profileType: 'Jenis usaha',
  profileOutlet: 'Cabang',
  emailLabel: 'Email',
  frozenHint: 'Kolom abu-abu hanya bisa diubah lewat tim GammaPOS.',
  moreSettings: 'Pengaturan lainnya',
  pwLinkHint: 'Ubah kata sandi untuk masuk ke web ini.',
  pwSub: 'Masukkan kata sandi saat ini, lalu kata sandi baru dua kali.',
  operatingLabel: 'Lama beroperasi',
  operatingNone: 'Belum diisi',
  operatingNames: { under_1: 'Kurang dari 1 tahun', '1_3': '1 sampai 3 tahun', '3_5': '3 sampai 5 tahun', over_5: 'Lebih dari 5 tahun' } as Record<string, string>,
  provinceLabel: 'Provinsi',
  cityLabel: 'Kota / Kabupaten',
  districtLabel: 'Kecamatan',
  pwTitle: 'Ganti kata sandi',
  pwHint: 'Setelah diganti, Anda tetap masuk di browser ini.',
  pwCurrent: 'Kata sandi saat ini',
  pwWrongCurrent: 'Kata sandi saat ini salah.',

  // ---------- close the account (ADR-0025): the same words as the cashier app
  deleteTitle: 'Hapus akun',
  deleteLinkHint: 'Tutup akun GammaPOS untuk usaha ini.',
  deleteSub: 'Anda akan menutup akun GammaPOS untuk usaha ini. Baca dulu apa yang terjadi.',
  deletePoints: [
    'Akun ditutup sekarang. Tidak ada yang bisa masuk lagi, di web maupun di device.',
    'Device kasir berhenti mencatat. Transaksi yang belum terkirim masih bisa dikirim.',
    'Data usaha disimpan 30 hari supaya Anda sempat mengunduhnya, lalu dihapus.',
    'Ingin membatalkan? Hubungi tim GammaPOS sebelum datanya dihapus.',
  ],
  deleteDownloadFirst: 'Unduh data Anda dulu. Satu file zip berisi transaksi, layanan, komisi, dan kas.',
  deletePassword: 'Kata sandi akun',
  deleteConfirm: 'Saya mengerti: akun ini ditutup dan tidak bisa dipakai lagi.',
  deleteButton: 'Hapus akun',
  deleteWrong: 'Kata sandi salah.',
  deleteMore: 'Baca selengkapnya',
  closedTitle: 'Akun sudah ditutup',
  closedBody: 'Tidak ada yang bisa masuk lagi, dan device kasir berhenti mencatat. Data usaha disimpan 30 hari supaya Anda sempat mengunduhnya, lalu dihapus.',
  closedHelp: 'Berubah pikiran? Anda bisa membuka kembali akun ini sendiri dengan kode SMS dalam 30 hari sejak ditutup.',
  closedContact: 'Buka halaman Kontak',
  closedLogin: 'Ke halaman masuk',
  pwNew: 'Kata sandi baru (min. 8 karakter)',
  pwConfirm: 'Ulangi kata sandi baru',
  pwSaved: 'Kata sandi sudah diganti.',
  rawExportBodyFor: (noun: string, staff: boolean) =>
    `Unduh semua transaksi, ${noun.toLowerCase()}${staff ? ', staf, dan aturan komisi' : ''} dalam satu file zip. Selalu tersedia.`,
  colDevice: 'Device',
  colDeviceStatus: 'Status',
  colActivated: 'Diaktifkan',
  colLastSync: 'Sinkron terakhir',
  colPendingData: 'Data belum terkirim',
  colItemName: 'Nama',
  colCategory: 'Kategori',
  colKind: 'Jenis',
  colPrice: 'Harga',
  itemDelete: 'Hapus',
  itemRestore: 'Aktifkan',
  itemDeleteAsk: (name: string) => `Hapus "${name}" dari kasir? Riwayat penjualan tetap ada. Bisa diaktifkan lagi.`,
  itemDeleteYes: 'Ya, hapus',
  itemDeleted: (name: string) => `"${name}" dihapus dari kasir.`,
  itemRestored: (name: string) => `"${name}" aktif lagi di kasir.`,
  outletInfoHint: 'Alamat dan nomor telepon dicetak di struk pelanggan.',
  subLinkHint: 'Masa langganan dan perpanjangan',
  devicesSub: 'Device yang dipakai kasir di cabang ini.',
  address: 'Alamat (dicetak di struk)',
  outletPhone: 'Nomor telepon (dicetak di struk)',
  receiptFooter: 'Pesan di bawah struk',
  saved: 'Tersimpan',
  outletSaved: 'Info cabang tersimpan. Dicetak di struk setelah device kasir sinkron.',

  // Dashboard and lists
  homeSub: 'Ringkasan penjualan cabang Anda.',
  salesSub: 'Semua transaksi dari device kasir. Ketuk satu untuk melihat rinciannya.',
  statCount: 'Transaksi',
  statDiscount: 'Diskon',
  statVoid: 'Dibatalkan',
  showAll: (n: number) => `Lihat semua (${n})`,
  showLess: 'Ringkas',
  colReceipt: 'No. struk',
  colCashier: 'Kasir',
  colOrder: 'Pesanan',
  colMethod: 'Pembayaran',
  colTotal: 'Total',
  salesShown: (n: number) => `${n} transaksi ditampilkan`,

  // Receipt logo
  logoTitle: 'Logo struk',
  logoBody: 'Dicetak di bagian atas struk. Pakai gambar sederhana: warna dan foto diubah menjadi titik hitam putih.',
  logoPick: 'Pilih gambar',
  logoChange: 'Ganti gambar',
  logoModeLabel: 'Hasil cetak',
  logoModeSharp: 'Tegas (logo, tulisan)',
  logoModePhoto: 'Foto (titik halus)',
  logoInvert: 'Balik hitam dan putih',
  logoPreview: 'Pratinjau cetak',
  logoSize: (w: number, h: number) => `${w} × ${h} titik`,
  logoSave: 'Simpan logo',
  logoRemove: 'Hapus logo',
  logoSaved: 'Logo tersimpan. Device kasir mencetaknya setelah sinkron berikutnya.',
  logoRemoved: 'Logo dihapus. Struk berikutnya dicetak tanpa logo setelah device kasir sinkron.',
  logoNone: 'Belum ada logo. Struk dicetak dengan nama usaha saja.',
  logoUnreadable: 'Gambar tidak bisa dibuka. Pakai file PNG, JPG, atau WebP.',
  logoTooBig: 'File terlalu besar. Pakai gambar di bawah 5 MB.',
  logoBlank: 'Tidak ada titik hitam yang bisa dicetak. Coba mode Foto, atau balik hitam dan putih.',

  // Reports (F&B lite)
  taxLine: 'Pajak (PB1)',
  serviceLine: 'Service',
  takeawayFeeLine: 'Biaya Take Away',
  roundingLine: 'Pembulatan',
  inPrice: 'sudah di harga',
  orderTypeTitle: 'Dine In / Take Away',
  dineIn: 'Dine In',
  takeaway: 'Take Away',
  noOrderType: 'Tanpa jenis pesanan',
  tableLabel: (label: string) => `Meja ${label}`,
  positionNote: (note: string) => `Catatan: ${note}`,
  itemNote: 'Catatan',

  // Cashier settings
  usersLink: 'Pengguna kasir',
  usersLinkHint: 'Tambah pengguna POS1, POS2, atur PIN, peran dan hak akses',
  kasirLink: 'Pengaturan kasir',
  layoutTitle: 'Tampilan struk',
  layoutSub: 'Atur cetak struk dan tiket dapur, pilih baris yang tampil di struk pelanggan, dan lihat hasilnya langsung. Berlaku di semua device kasir setelah sinkron.',
  layoutLinkHint: 'Petugas kasir, nomor struk, baris tambahan, garis pembatas, dengan pratinjau',
  layoutPreview: 'Pratinjau struk',
  layoutPreviewNote: (n: number) => `Persis seperti yang dicetak printer kertas 58 mm (${n} karakter selebar kertas).`,
  layoutSampleCharges: 'Contoh dengan diskon, service, dan PB1',
  layoutGroupBusiness: 'Usaha',
  layoutLogo: 'Logo struk',
  layoutLogoHint: 'Tampil di paling atas struk. Gambar disimpan di bawah; matikan untuk menyembunyikannya tanpa menghapus.',
  layoutAddress: 'Alamat',
  layoutPhone: 'Nomor telepon',
  layoutLineTop: 'Baris tambahan di atas',
  layoutLineTopHint: 'Satu baris pendek di bawah nama usaha, mis. akun Instagram. Kosongkan bila tidak perlu.',
  layoutGroupSale: 'Transaksi',
  layoutNumber: 'Nomor struk',
  layoutNumberHint: 'Di bawah: ditaruh di tengah setelah teks penutup, dengan garis di atas dan di bawahnya.',
  layoutNumberHiddenWarning: 'Tanpa nomor, pelanggan tidak punya rujukan untuk komplain atau pembatalan. Transaksi tetap bisa dicari lewat jam dan jumlah.',
  layoutNumberTop: 'Di atas',
  layoutNumberBottom: 'Di bawah',
  layoutNumberHidden: 'Sembunyikan',
  layoutCashier: 'Petugas kasir',
  layoutCashierHint: 'Baris "Kasir POS1".',
  layoutOrderLine: 'Meja dan jenis pesanan',
  layoutGroupItems: 'Item',
  layoutItemDetail: 'Harga satuan',
  layoutItemDetailHint: 'Baris "2 x 17.000". Jumlah dan total tiap item tetap tampil.',
  layoutStaff: 'Nama staf per item',
  layoutItemCount: 'Jumlah item',
  layoutGroupPayment: 'Pembayaran',
  layoutPaymentMethod: 'Cara bayar',
  layoutCashChange: 'Dibayar dan kembalian',
  layoutGroupClosing: 'Penutup',
  layoutFooter: 'Teks penutup',
  layoutFooterHint: 'Tampilkan teks penutup di struk.',
  layoutFooterText: 'Kalimat penutup',
  layoutFooterTextHint: 'Kosongkan untuk "Terima kasih".',
  layoutFooterPlaceholder: 'Terima kasih',
  layoutFooterAlign: 'Posisi teks penutup',
  layoutAlignCenter: 'Tengah',
  layoutAlignLeft: 'Kiri',
  layoutLineBottom: 'Baris tambahan di bawah',
  layoutLineBottomHint: 'Satu baris pendek di bawah teks penutup, mis. sandi Wi-Fi atau promo.',
  layoutGroupLook: 'Tampilan',
  layoutDivider: 'Garis pembatas',
  layoutDividerDash: 'Garis ( - - - )',
  layoutDividerEquals: 'Garis ganda ( = = = )',
  layoutDividerNone: 'Tanpa garis',
  layoutBlankLines: 'Spasi kosong di akhir',
  layoutBlankLinesHint: 'Agar struk tidak tertahan di pemotong printer.',
  layoutBlank: (n: number) => (n === 0 ? 'Tanpa' : `${n} baris`),
  layoutElsewhere: 'Catatan dapur di struk diatur di',
  layoutSaved: 'Tersimpan. Device kasir memakai tampilan baru setelah sinkron berikutnya.',
  kasirLinkHint: 'Pajak, service, pembulatan, meja, catatan, tiket dapur',
  emenuTitle: 'E-menu',
  topMenu: 'Menu terlaris',
  topProducts: 'Produk terlaris',
  topItems: 'Layanan & produk terlaris',
  staffColItems: 'Item',
  staffColServices: 'Layanan',
  emenuSub: 'Menu digital untuk tamu lewat QR.',
  emenuSwitchTitle: 'Menu digital',
  emenuSwitch: 'Nyalakan e-menu',
  emenuSwitchOnHint: 'Siapa pun yang punya link atau QR bisa melihat menu dan harga. Perubahan menu tampil dalam 1 menit setelah sinkron.',
  emenuSwitchOffHint: 'Menu belum bisa dibuka tamu. QR yang sudah dicetak tetap berlaku saat dinyalakan.',
  emenuOnSaved: 'E-menu menyala.',
  emenuOffSaved: 'E-menu dimatikan.',
  emenuAddressTitle: 'Alamat menu',
  emenuAddressLabel: 'Ubah alamat',
  emenuAddressHint: 'Huruf kecil, angka, dan tanda hubung, 3 sampai 40 karakter. Alamat lama tetap mengarah ke menu ini.',
  emenuAddressSave: 'Simpan alamat',
  emenuAddressSaved: 'Alamat tersimpan.',
  emenuCopy: 'Salin link',
  emenuCopied: 'Link tersalin',
  emenuQrTitle: 'QR menu cabang',
  emenuQrAlt: 'QR menu cabang',
  emenuQrHint: 'Cetak dan letakkan di meja atau kasir. Tamu scan untuk melihat menu.',
  emenuQrOffHint: 'Nyalakan e-menu dulu supaya QR ini bisa dibuka tamu. QR boleh diunduh sekarang.',
  emenuQrDownload: 'Unduh QR',
  emenuOrderingTitle: 'Pesanan QR',
  emenuOrderingSwitch: 'Terima pesanan QR',
  emenuOrderingHint: 'Tamu scan QR meja, lalu pesanannya masuk ke Pesanan aktif di aplikasi kasir. Hanya untuk usaha dengan langganan aktif.',
  emenuOrderingNeedsMenu: 'Nyalakan e-menu dulu.',
  emenuOrderingOnSaved: 'Pesanan QR menyala.',
  emenuOrderingOffSaved: 'Pesanan QR dimatikan.',
  emenuCashierNever: 'Device kasir belum terhubung. Tamu diarahkan ke kasir sampai aplikasi kasir versi terbaru terpasang dan terbuka.',
  emenuCashierOnline: (time: string) => `Device kasir terhubung, terakhir terlihat ${time}.`,
  emenuCashierOffline: (time: string) => `Device kasir tidak terhubung sejak ${time}. Tamu diarahkan ke kasir.`,
  emenuTablesTitle: 'QR meja',
  emenuTablesHint: 'Satu QR untuk tiap meja di daftar meja. Mengganti nama meja membuat QR baru, jadi cetak ulang QR-nya.',
  emenuTablesEmpty: 'Belum ada daftar meja.',
  emenuTablesEmptyLink: 'Isi di Pengaturan kasir',
  emenuTablesPrint: 'Cetak kartu meja',
  emenuTableName: (label: string) => `Meja ${label}`,
  emenuTableDownload: (label: string) => `Unduh QR Meja ${label}`,
  emenuTableRotate: (label: string) => `Ganti QR Meja ${label}`,
  emenuQrRotateConfirm: (label: string) => `QR Meja ${label} yang sudah dicetak langsung tidak berlaku. Lanjutkan?`,
  emenuQrRotated: (label: string) => `QR Meja ${label} sudah diganti. Cetak QR yang baru.`,
  emenuTentScan: 'Scan untuk pesan',
  emenuPhotosTitle: 'Foto menu',
  emenuPhotosHint: 'Foto bersifat opsional. Tambahkan dari form tiap item di halaman menu.',
  emenuPhotosOff: 'Foto menu belum bisa diunggah. Menu tetap tampil tanpa foto.',
  emenuPhotoLabel: 'Foto di e-menu',
  emenuPhotoPick: 'Pilih foto',
  emenuPhotoChange: 'Ganti foto',
  emenuPhotoRemove: 'Hapus foto',
  emenuPhotoBusy: 'Menyimpan...',
  emenuPhotoHint: 'Opsional. Foto langsung tersimpan dan otomatis dikecilkan.',
  emenuPhotoSaveFirst: 'Simpan item dulu, lalu buka lagi untuk menambah foto.',
  emenuPhotoUnreadable: 'Foto ini tidak bisa dibaca atau terlalu besar. Pilih foto JPG atau PNG lain.',
  kasirTitle: 'Pengaturan kasir',
  kasirSub: 'Pajak, service, pesanan, dan catatan dapur. Berlaku di semua device kasir setelah sinkron.',
  subSub: 'Masa langganan Anda dan cara memperpanjang.',
  kasirBusinessSection: 'Jenis usaha',
  kasirBusinessNow: (type: string) => `Jenis usaha cabang ini: ${type}`,
  kasirApplyProfile: 'Terapkan pengaturan awal',
  kasirSwitchTo: (type: string) => `Ganti ke ${type}`,
  kasirApplyConfirmTitle: (type: string) => `Terapkan pengaturan awal ${type}?`,
  kasirApplyConfirmBody: 'Pengaturan berikut akan berubah. Pengaturan lain yang Anda ubah sendiri ikut kembali ke awal.',
  kasirApplyNothing: 'Pengaturan Anda sudah sama dengan pengaturan awal.',
  kasirApplyYes: 'Ya, terapkan',
  kasirApplyNo: 'Batal',
  // ---------- Ganti jenis usaha (a page of its own under Info outlet)
  typeTitle: 'Ganti jenis usaha',
  typeLinkHint: 'Menu, transaksi, dan staf tetap ada.',
  typeSub: 'Jenis usaha mengubah kata-kata dan fitur yang tampil. Menu, transaksi, staf, dan riwayat tidak dihapus.',
  typeNow: (type: string) => `Jenis usaha sekarang: ${type}`,
  typePick: 'Ganti ke',
  typeChangesTitle: (type: string) => `Yang berubah bila diganti ke ${type}`,
  typeKept: 'Menu, transaksi, staf, sesi kas, dan device tidak dihapus. Pengaturan kasir lain yang Anda ubah sendiri ikut kembali ke pengaturan awal jenis ini.',
  typeButton: 'Ganti jenis usaha',
  typeDone: (type: string) => `Jenis usaha sekarang ${type}. Pengaturan awalnya sudah diterapkan dan device kasir memakainya setelah sinkron.`,
  typeLinkSettings: 'Ganti jenis usaha',
  kasirTaxSection: 'Pajak & service',
  kasirTaxEnabled: 'Pajak restoran (PB1)',
  kasirTaxRate: 'Tarif pajak (%)',
  kasirServiceEnabled: 'Service charge',
  kasirServiceRate: 'Tarif service (%)',
  kasirInclusive: 'Harga menu sudah termasuk pajak & service',
  kasirInclusiveHint: 'Struk menampilkan pajak dan service yang sudah ada di harga, tidak menambah total.',
  kasirRounding: 'Bulatkan total ke Rp 100',
  kasirRateInvalid: 'Isi tarif 0 sampai 25, mis. 10 atau 2,5.',
  kasirPreviewTitle: 'Contoh pesanan Rp 48.000',
  kasirPreview: (service: string, tax: string, rounding: string, total: string) =>
    `Service ${service} · PB1 ${tax} · Pembulatan ${rounding} · Total ${total}`,
  kasirOrderSection: 'Pesanan',
  kasirOrderType: 'Tanyakan Dine In atau Take Away',
  kasirTakeawayFee: 'Biaya Take Away per pesanan (Rp, kosongkan jika tidak ada)',
  kasirTakeawayFeeInvalid: 'Biaya Take Away 0 sampai 100.000.',
  kasirTable: 'Catat nomor meja',
  kasirTableRequired: 'Wajib pilih meja sebelum memilih menu',
  kasirTableRequiredHint:
    'Kasir melihat tombol-tombol meja lebih dulu, plus tombol Lainnya (dengan catatan posisi) untuk pelanggan yang tidak duduk di meja bernomor.',
  kasirTableList: 'Daftar meja',
  kasirTableNew: 'Tambah satu meja',
  kasirTableNewHint: 'mis. 12 atau VIP1',
  kasirTableAdd: 'Tambah meja',
  kasirTableRemove: (n: string) => `Hapus meja ${n}`,
  kasirTableRangeLabel: 'Buat meja 1 sampai',
  kasirTableRangeHint: 'mis. 10',
  kasirTableRangeButton: 'Buat daftar',
  kasirTableLimit: 'Sampai 200 meja, masing-masing sampai 12 karakter: angka atau huruf, mis. 1, 2, VIP1.',
  kasirTableNeedsList: 'Isi daftar meja dulu supaya pilih meja bisa diwajibkan.',
  kasirItemNotes: 'Catatan per menu (mis. tidak pedas)',
  kasirPresets: 'Catatan cepat',
  kasirPresetNew: 'Catatan baru',
  kasirPresetNewHint: 'mis. Tanpa bawang',
  kasirPresetAdd: 'Tambah catatan',
  kasirPresetRemove: (p: string) => `Hapus catatan ${p}`,
  kasirPresetLimit: 'Paling banyak 10 catatan, masing-masing sampai 30 huruf.',
  kasirStaffSection: 'Staf',
  kasirStaffPerLine: 'Tanya siapa yang mengerjakan tiap item',
  kasirStaffPerLineHint: 'Bila dinyalakan, menu Staf dan Komisi muncul di web dan aplikasi kasir.',
  kasirStaffPerLineOffHint: 'Usaha ini biasanya tidak memakai komisi. Setelah dimatikan dan disimpan, saklar ini hilang. Riwayat komisi lama tetap ada di laporan.',
  kasirPrintSection: 'Cetak dan struk',
  printSub: 'Sama dengan menu Printer di aplikasi kasir.',
  printReceiptTitle: 'Struk pelanggan',
  printReceiptCopies: 'Jumlah cetak struk',
  printReceiptCopiesHint: 'Berapa kali struk pelanggan dicetak untuk setiap transaksi.',
  printDigital: 'Tombol struk digital',
  printDigitalHint: 'Tampilkan tombol untuk mengirim struk lewat WhatsApp dan sejenisnya, setelah bayar dan di riwayat.',
  printNotes: 'Catatan menu di struk',
  printNotesHint: 'Tulis catatan tiap menu, misalnya "tidak pedas", di struk pelanggan.',
  printKitchenTitle: 'Tiket dapur',
  printKitchen: 'Cetak tiket dapur',
  printKitchenHint: 'Tampilkan tombol cetak daftar pesanan untuk dapur. Dicetak terpisah dari struk pelanggan.',
  printKitchenCopies: 'Jumlah cetak tiket dapur',
  printKitchenCopiesHint: 'Berapa lembar tiket dapur setiap kali dicetak.',
  printSheets: (n: number) => `${n} lembar`,
  kasirOpenBillSection: 'Bayar nanti (open bill)',
  kasirOpenBill: 'Izinkan pesanan dibayar nanti',
  kasirOpenBillHint:
    'Pesanan disimpan di device kasir sampai dibayar. Pesanan yang belum dibayar tidak masuk laporan dan hanya ada di device itu. Kalau device hilang atau rusak, pesanan itu ikut hilang.',
  cashDrawerSection: 'Kas awal dan tutup kas',
  cashDrawerEnabled: 'Pakai kas awal dan tutup kas',
  cashDrawerEnabledHint: 'Kasir mengisi uang di laci saat buka dan menghitungnya saat tutup. Selisihnya tercatat.',
  cashDrawerOffWarn:
    'Kalau dimatikan, kasir tidak melihat layar kas awal dan tutup kas, dan menu Kas awal (termasuk kas masuk dan kas keluar) hilang dari device. Selisih uang di laci tidak lagi terdeteksi.',
  cashDrawerDefault: 'Kas awal bawaan (Rp)',
  cashDrawerDefaultHint: 'Layar kas awal sudah terisi nominal ini. Kasir tinggal menekan Buka kas. Kosongkan untuk 0.',
  cashDrawerDefaultInvalid: 'Isi angka rupiah antara 0 dan 1.000.000.000.',
  businessDayStart: 'Jam buka',
  businessDayEnd: 'Jam tutup',
  businessDayHint:
    'Penjualan sebelum jam buka (misalnya pukul 01.00) masuk ke hari bisnis sebelumnya. Penjualan sesudah jam tutup tidak pernah ditolak.',
  businessDayInvalid: 'Jam tutup harus sesudah jam buka.',
  cashSessionAuto: 'Otomatis',
  demoShown: 'Menampilkan data contoh. Angka di halaman ini belum penjualan asli toko Anda.',
  demoMixed: 'Data contoh ikut dihitung bersama penjualan asli.',
  demoHidden: 'Ada data contoh di toko ini. Angka di halaman ini hanya penjualan asli.',
  demoShowToggle: 'Tampilkan data contoh',
  demoRemove: 'Hapus data contoh',
  demoConfirmTitle: 'Hapus data contoh?',
  demoConfirmBody: (sales: number, from: string, to: string) =>
    `${sales} transaksi contoh (${from} sampai ${to}) akan dihapus dari web dan dari device kasir. Penjualan asli tidak ikut terhapus.`,
  demoConfirmYes: 'Ya, hapus data contoh',
  demoConfirmNo: 'Batal',
  demoRemoving: 'Menghapus...',
  demoRemoved: 'Data contoh dihapus.',
  storeHours: (a: string, b: string) => `Jam buka ${a.replace(':', '.')} sampai ${b.replace(':', '.')}`,
  kasirSaved: 'Tersimpan. Device kasir memakai pengaturan baru setelah sinkron berikutnya.',
  kasirSave: 'Simpan pengaturan',
  kasirOn: 'aktif',
  kasirOff: 'mati',
  kasirFieldNames: {
    staff_per_line_enabled: 'Tanya siapa yang mengerjakan tiap item',
    tax_enabled: 'Pajak',
    tax_rate_bps: 'Tarif pajak',
    service_enabled: 'Service charge',
    service_rate_bps: 'Tarif service',
    prices_include_tax: 'Harga sudah termasuk pajak',
    rounding_unit: 'Pembulatan Rp 100',
    order_type_enabled: 'Dine In / Take Away',
    takeaway_fee_amount: 'Biaya Take Away',
    table_number_enabled: 'Nomor meja',
    table_required: 'Wajib pilih meja',
    table_list: 'Daftar meja',
    item_notes_enabled: 'Catatan per menu',
    note_presets: 'Catatan cepat',
    receipt_show_notes: 'Catatan di struk pelanggan',
    kitchen_ticket_enabled: 'Tiket dapur',
    kitchen_ticket_copies: 'Lembar tiket dapur',
    open_bill_enabled: 'Bayar nanti',
  } as Record<string, string>,

  // Karyawan (CASHIER_USERS_PLAN)
  usersTitle: 'Pengguna kasir',
  usersSub: 'Siapa yang bisa membuka device kasir, dengan PIN apa, dan apa yang boleh dilakukannya.',
  usersListTitle: 'Daftar pengguna kasir',
  usersEmpty: 'Belum ada pengguna kasir lain. Tambahkan pengguna kasir yang akan memakai device kasir.',
  usersAdd: 'Tambah pengguna kasir',
  userName: 'Nama (mis. POS2)',
  userRole: 'Peran',
  userPin: 'PIN (6 angka)',
  userPinAgain: 'Ulangi PIN',
  userPinNew: 'PIN baru (6 angka)',
  userPinRandom: 'Buat PIN acak',
  userPinShown: (pin: string) => `PIN ${pin}. Catat dan berikan ke orangnya; setelah disimpan PIN tidak bisa dilihat lagi.`,
  userPinMismatch: 'PIN tidak sama. Ketik ulang.',
  userPinBad: 'PIN harus 6 angka.',
  userSave: 'Simpan pengguna kasir',
  userSaved: 'Pengguna kasir disimpan. Device kasir mendapatkannya saat tersambung.',
  userEdit: 'Ubah',
  userOff: 'Nonaktifkan',
  userOn: 'Aktifkan lagi',
  userOnNeedsPin: 'Untuk mengaktifkan lagi, buat PIN baru.',
  userCancel: 'Batal',
  userChangePin: 'Ganti PIN',
  userStatusOn: 'Aktif',
  userStatusOff: 'Nonaktif',
  roleOwner: 'Pemilik',
  roleManajer: 'Manajer',
  rolePengguna: 'Pengguna',
  roleCashier: 'Kasir',
  roleOwnerFixed: 'Pemilik selalu punya semua hak.',
  lockTitle: 'Layar kunci',
  lockShowUsers: 'Tampilkan daftar pengguna kasir di layar kunci',
  lockShowUsersHint:
    'Dimatikan: kasir cukup mengetik PIN dan langsung masuk sebagai pemilik PIN itu, tanpa daftar nama. Karena itu PIN setiap pengguna kasir harus berbeda.',
  rightsTitle: 'Hak akses per peran',
  rightsHint:
    'Pengguna yang perannya tidak punya hak tetap bisa melakukannya, tetapi harus dengan PIN pemilik. Pemilik selalu punya semua hak.',
  rightsSave: 'Simpan hak akses',
  rightsSaved: 'Hak akses disimpan.',
  rightsRight: 'Hak',
  rights: {
    report: 'Melihat laporan',
    history: 'Melihat daftar riwayat transaksi',
    void: 'Membatalkan transaksi',
    discount: 'Memberi diskon',
    cash: 'Buka atau tutup kas, kas masuk dan keluar',
    menu_edit: 'Mengubah menu, harga dan kategori',
    staff_edit: 'Mengelola staf dan komisi',
    users_edit: 'Mengelola pengguna kasir di device',
    kitchen_change: 'Mengubah pesanan yang sudah ke dapur',
  },
} as const

const errors: Record<string, string> = {
  invalid_credentials: 'Nomor HP atau kata sandi salah.',
  too_many_attempts: 'Terlalu banyak percobaan. Coba lagi dalam 15 menit.',
  invalid_invite: 'Kode undangan salah atau sudah dipakai.',
  phone_taken: 'Nomor HP ini sudah terdaftar. Silakan masuk.',
  account_closed: 'Akun dengan nomor ini sudah ditutup. Anda bisa membukanya kembali dengan kode SMS dalam 30 hari sejak ditutup; setelah itu datanya dihapus dan nomor ini bisa dipakai mendaftar lagi.',
  table_list_required: 'Isi daftar meja dulu supaya pilih meja bisa diwajibkan.',
  otp_invalid: 'Kode salah. Periksa SMS Anda lalu coba lagi.',
  otp_expired: 'Kode sudah kedaluwarsa. Minta kode baru.',
  otp_too_many_attempts: 'Terlalu banyak percobaan. Minta kode baru.',
  otp_cooldown: 'Tunggu sebentar sebelum meminta kode lagi.',
  otp_rate_limited: 'Terlalu banyak permintaan kode. Coba lagi nanti.',
  sms_unavailable: 'Pengiriman SMS sedang tidak tersedia. Coba lagi sebentar lagi.',
  phone_not_verified: 'Nomor HP belum diverifikasi. Minta kode baru.',
  otp_disabled: 'Reset kata sandi lewat SMS belum aktif. Hubungi tim GammaPOS.',
  pin_taken: 'PIN ini sudah dipakai pengguna lain. Pilih PIN yang berbeda.',
  pin_required: 'Untuk mengaktifkan lagi, buat PIN baru.',
  last_owner: 'Pemilik terakhir tidak bisa dinonaktifkan.',
  owner_role_fixed: 'Peran pemilik tidak bisa diubah.',
  invalid_phone: 'Nomor HP tidak dikenali. Gunakan nomor HP Indonesia, mis. 0812…',
  wrong_password: 'Kata sandi sementara salah.',
  invalid_request: 'Ada isian yang belum benar.',
  emenu_slug_taken: 'Alamat ini sudah dipakai. Pilih yang lain.',
  emenu_ordering_food_only: 'Pesanan QR hanya untuk usaha Makanan & Minuman.',
  emenu_ordering_needs_menu: 'Nyalakan e-menu dulu.',
  emenu_ordering_needs_tables: 'Isi daftar meja dulu di Pengaturan kasir.',
  emenu_slug_invalid: 'Alamat hanya boleh huruf kecil, angka, dan tanda hubung.',
  emenu_photo_type: 'Foto harus berupa JPG atau WebP.',
  emenu_photo_too_large: 'Foto terlalu besar. Pilih foto lain.',
  emenu_photos_unavailable: 'Foto menu belum bisa diunggah. Coba lagi nanti.',
  network: 'Tidak ada internet. Coba lagi.',
  subscription_required: 'Langganan berakhir. Perpanjang untuk membuka laporan.',
  voucher_invalid: 'Kode voucher tidak dikenali atau sudah kedaluwarsa.',
  voucher_used_up: 'Voucher ini sudah habis dipakai.',
  voucher_already_redeemed: 'Voucher ini sudah pernah Anda pakai.',
  payment_provider_unavailable: 'Layanan pembayaran sedang tidak bisa dihubungi. Coba lagi sebentar lagi.',
  billing_not_configured: 'Pembayaran online belum aktif. Hubungi tim GammaPOS.',
  unknown_plan: 'Paket tidak dikenali. Muat ulang halaman.',
  version_conflict: 'Data ini baru saja diubah di tempat lain (device kasir atau tab lain). Muat ulang, lalu ubah lagi.',
  rule_exists: 'Sudah ada aturan komisi aktif untuk layanan dan staf ini. Ubah aturan yang ada.',
  unknown_reference: 'Layanan atau staf itu tidak ditemukan. Muat ulang halaman.',
  rate_above_100_percent: 'Komisi persen tidak boleh lebih dari 100%.',
  unsent_not_acknowledged: 'Centang dulu pernyataan bahwa Anda mengerti transaksi device lama bisa hilang.',
  invalid_range: 'Tanggal akhir sebelum tanggal awal.',
  range_too_long: 'Periode paling lama satu tahun.',
  no_logo: 'Belum ada logo.',
}

export function errorMessage(code: string): string {
  return errors[code] ?? 'Terjadi kesalahan. Coba lagi sebentar lagi.'
}
